import PropTypes from 'prop-types';

/**
 * @typedef {Object} UserOrganisationInfoData
 * @property {string} organisationLogoUrl
 * @property {string} organisationName
 */

export const userOrganisationInfoShape = PropTypes.shape({
  organisationLogoUrl: PropTypes.string,
  organisationName: PropTypes.string
});
